// import waypoints from node_modules
import 'waypoints/lib/jquery.waypoints';
import 'waypoints/lib/shortcuts/sticky';


jQuery(function($) {
    let currentSticky = null;
    let resizeTimeout = null;

    const navigationSticky = () => {
        //If sticky is true and contains 'destroy' function: destroy currentSticky to prevent double stickies
        if (currentSticky && typeof currentSticky.destroy === 'function') {
            currentSticky.destroy();
            currentSticky = null;
        }

        if ($(window).width() > 993) {
            currentSticky = desktopMenu();
        }

        if ($(window).width() < 992) {
            currentSticky = mobileMenu();
        }
    }

    //Debounced resize handler
    $(window).resize(function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(navigationSticky, 200);
    });

    navigationSticky();

    //Menu for desktop
    function desktopMenu() {
        return new Waypoint.Sticky({
            element: $('.header-nav-desktop'),
        });
    }

    //Menu for tablet and mobile
    function mobileMenu() {
        return new Waypoint.Sticky({
            element: $('.header'),
        });
    }
});